import React, { useContext, useState, useEffect, useCallback } from 'react'
import { graphql, useStaticQuery } from 'gatsby'
import { GatsbyImage } from 'gatsby-plugin-image'
import { useTranslation, Trans } from 'gatsby-plugin-react-i18next'

import Spinner from 'src/components/Spinner'
import LoadingEllipsis from 'src/components/LoadingEllipsis'
import StoreContext from 'src/context/StoreContext'
import theme from 'src/utils/styles/theme'
import Analytics from 'src/utils/Analytics'
import UTMParams from 'src/utils/UTMParams'
import LocalStorage from 'src/utils/LocalStorage'
import { CenteredContent } from 'src/utils/styles/global-styles'
import loadingGif from 'src/gifs/loading.gif'
import { FormattedCurrency } from 'src/utils/FormattedCurrency'
import ShopPay from 'src/components/temp/ShopPay'
import ToolTip from 'src/components/temp/ToolTip'
// import { Centered } from 'src/components/FrameProductForm/styles'
// import YotpoStars from 'src/components/YotpoStars'
// import BetterHelpOffer from 'src/components/temp/BetterHelpOffer'
import {
  currencyCode,
  IN_AU,
  IN_UK,
  RETURN_GUARANTEE_PRODUCT_HANDLE,
  LOVEVERY_PRODUCT_HANDLE,
  IS_FOREIGN_COUNTRY,
  // IN_CA,
  // BUY_LINK,
  // FRAME_UPSELL_COLOR,
  // LOCALIZATION,
  // CURRENT_SEASONAL_STATE,
  // SHOW_BETTER_HELP_DESIGN,
  VIP_CODE,
  IN_SEASONAL_STATE,
} from 'src/utils/constants'
import PropTypes from 'prop-types'
import ProductsList from '../ProductsList'
import LineItem from './LineItem'
import Popup from '../Popup'
import CalendarSnapFrameCrossSell from './CalendarSnapFrameCrossSell'
// import AddToCartButton from '../AddToCartButton'
import // BLACK_FRAME_VARIANT_ID,
// FRAME_OG_PRICE,
// FRAME_DISCOUNTED_PRICE,
// FRAME_OG_PRICE_BAU,
// FRAME_DISCOUNTED_PRICE_BAU,
'../../templates/CalendarProductPage/constants.js'

import {
  Table,
  TableHeader,
  DesktopOnlyTableHeader,
  Checkout,
  LineItemTotal,
  CheckoutButton,
  Excluding,
  PayPalCheckoutButton,
  CheckoutButtons,
  Discount,
  Total,
  QuantityHeader,
  TableRow,
  TD,
  DisplayOnDesktop,
  DisplayOnMobile,
  Amount,
  Container,
  HiddenOnDesktop,
  CheckoutContainer,
  Header,
  ProductListContainer,
  DiscountText,
  Subtotal,
  Error,
  Offer,
  // Banner,
  // BannerText,
  // RedText,
  // FrameDealImage,
  // Strikethrough,
  // TextContainer,
  // HiddenImageOnDesktop,
  // DiscountBadge,
} from './styles'
import { shouldRemoveReturnGuarantee } from '../../utils/addReturnGuarantee'
import { shouldRemoveBetterHelpProduct } from '../../utils/addBetterHelp'

const Cart = ({ handleAddToCart, submitting }) => {
  const { t } = useTranslation('common')

  const {
    store: {
      cart,
      loading,
      banner: { promoCode },
    },
    applyDiscount,
    isUserBuyingPlus,
    isUserBuyingCalendar,
    removeLineItem,
  } = useContext(StoreContext)
  const {
    paypalLogo,
    snapFrame,
    cartUpsellProducts,
    snapFrameFallbackImage,
    cal2ClassicBlackImage,
    cal2ClassicWhiteImage,
    cal2ClassicSageImage,
    cal2ClassicLagoonImage,
    cal2ShadowBoxCharcoalImage,
    cal2ShadowBoxSilverImage,
    calMaxClassicBlackImage,
    calMaxClassicWhiteImage,
    calMaxShadowBoxCharcoalImage,
    calMaxShadowBoxSilverImage,
    calMaxWoodBirchImage,
    calMaxWoodWalnutImage,
    // frameBlackDeal,
    // frameSilverDeal,
    // frameSilverDealDesktop,
    // Badge_60,
    // Badge_30,
  } = useStaticQuery(graphql`
    query CartQuery {
      paypalLogo: file(relativePath: { eq: "paypal-logo.webp" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, width: 75, height: 21, layout: FIXED, placeholder: NONE)
        }
      }
      frameSilverDealDesktop: file(relativePath: { eq: "silver-frame-special-deal-desktop.webp" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, layout: FULL_WIDTH, placeholder: NONE)
        }
      }
      frameBlackDeal: file(relativePath: { eq: "black-frame-special-deal.webp" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, layout: FULL_WIDTH, placeholder: NONE)
        }
      }
      frameSilverDeal: file(relativePath: { eq: "silver-frame-special-deal.webp" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, layout: FULL_WIDTH, placeholder: NONE)
        }
      }
      snapFrame: shopifyProduct(handle: { eq: "snap-frame" }) {
        id
        title
        handle
        shopifyId
        variants {
          id
          title
          price
          shopifyId
          sku
        }
      }
      snapFrameFallbackImage: file(relativePath: { eq: "frame2/snap-frame-style.jpg" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, width: 220, layout: CONSTRAINED, placeholder: NONE)
        }
      }
      cal2ClassicBlackImage: file(
        relativePath: {
          eq: "calendar-snap-frame/Cal 2/Selection/cal_2_classic_black_style_color_image@2x.png"
        }
      ) {
        childImageSharp {
          gatsbyImageData(quality: 100, width: 220, layout: CONSTRAINED, placeholder: NONE)
        }
      }
      cal2ClassicWhiteImage: file(
        relativePath: {
          eq: "calendar-snap-frame/Cal 2/Selection/cal_2_classic_white_style_color_image@2x.png"
        }
      ) {
        childImageSharp {
          gatsbyImageData(quality: 100, width: 220, layout: CONSTRAINED, placeholder: NONE)
        }
      }
      cal2ClassicSageImage: file(
        relativePath: {
          eq: "calendar-snap-frame/Cal 2/Selection/cal_2_classic_sage_style_color_image@2x.png"
        }
      ) {
        childImageSharp {
          gatsbyImageData(quality: 100, width: 220, layout: CONSTRAINED, placeholder: NONE)
        }
      }
      cal2ClassicLagoonImage: file(
        relativePath: {
          eq: "calendar-snap-frame/Cal 2/Selection/cal_2_classic_lagoon_style_color_image@2x.png"
        }
      ) {
        childImageSharp {
          gatsbyImageData(quality: 100, width: 220, layout: CONSTRAINED, placeholder: NONE)
        }
      }
      cal2ShadowBoxCharcoalImage: file(
        relativePath: {
          eq: "calendar-snap-frame/Cal 2/Selection/cal_2_sb_black_style_color_image@2x.png"
        }
      ) {
        childImageSharp {
          gatsbyImageData(quality: 100, width: 220, layout: CONSTRAINED, placeholder: NONE)
        }
      }
      cal2ShadowBoxSilverImage: file(
        relativePath: {
          eq: "calendar-snap-frame/Cal 2/Selection/cal_2_sb_silver_style_color_image@2x.png"
        }
      ) {
        childImageSharp {
          gatsbyImageData(quality: 100, width: 220, layout: CONSTRAINED, placeholder: NONE)
        }
      }
      calMaxClassicBlackImage: file(
        relativePath: {
          eq: "calendar-snap-frame/Cal Max/Selection/calmax_classic_black_style_color_image.png"
        }
      ) {
        childImageSharp {
          gatsbyImageData(quality: 100, width: 220, layout: CONSTRAINED, placeholder: NONE)
        }
      }
      calMaxClassicWhiteImage: file(
        relativePath: {
          eq: "calendar-snap-frame/Cal Max/Selection/calmax_classic_white_style_color_image.png"
        }
      ) {
        childImageSharp {
          gatsbyImageData(quality: 100, width: 220, layout: CONSTRAINED, placeholder: NONE)
        }
      }
      calMaxShadowBoxCharcoalImage: file(
        relativePath: {
          eq: "calendar-snap-frame/Cal Max/Selection/calmax_sb_black_style_color_image.png"
        }
      ) {
        childImageSharp {
          gatsbyImageData(quality: 100, width: 220, layout: CONSTRAINED, placeholder: NONE)
        }
      }
      calMaxShadowBoxSilverImage: file(
        relativePath: {
          eq: "calendar-snap-frame/Cal Max/Selection/calmax_sb_silver_style_color_image.png"
        }
      ) {
        childImageSharp {
          gatsbyImageData(quality: 100, width: 220, layout: CONSTRAINED, placeholder: NONE)
        }
      }
      calMaxWoodBirchImage: file(
        relativePath: {
          eq: "calendar-snap-frame/Cal Max/Selection/calmax_wood_birch_style_color_image.png"
        }
      ) {
        childImageSharp {
          gatsbyImageData(quality: 100, width: 220, layout: CONSTRAINED, placeholder: NONE)
        }
      }
      calMaxWoodWalnutImage: file(
        relativePath: {
          eq: "calendar-snap-frame/Cal Max/Selection/calmax_wood_walnut_style_color_image.png"
        }
      ) {
        childImageSharp {
          gatsbyImageData(quality: 100, width: 220, layout: CONSTRAINED, placeholder: NONE)
        }
      }
      frameSilverDealDesktop: file(relativePath: { eq: "silver-frame-special-deal-desktop.webp" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, layout: FULL_WIDTH, placeholder: NONE)
        }
      }
      frameBlackDeal: file(relativePath: { eq: "black-frame-special-deal.webp" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, layout: FULL_WIDTH, placeholder: NONE)
        }
      }
      frameSilverDeal: file(relativePath: { eq: "silver-frame-special-deal.webp" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, layout: FULL_WIDTH, placeholder: NONE)
        }
      }
      Badge_60: file(relativePath: { eq: "md2026/60DollarBadge.webp" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, layout: FULL_WIDTH, placeholder: NONE)
        }
      }
      Badge_30: file(relativePath: { eq: "md2026/30DollarBadge.webp" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, layout: FULL_WIDTH, placeholder: NONE)
        }
      }
      cartUpsellProducts: allShopifyProduct(
        filter: { handle: { in: ["snap-frame", "calendar-2-snap", "cal-max-snap-frame"] } }
      ) {
        nodes {
          handle
          title
          shopifyId
          images {
            gatsbyImageData
          }
          variants {
            id
            title
            price
            shopifyId
            sku
          }
        }
      }
    }
  `)
  const calendar2SnapFrame =
    cartUpsellProducts?.nodes?.find((product) => product.handle === 'calendar-2-snap') || null
  const calendarMaxSnapFrame =
    cartUpsellProducts?.nodes?.find((product) => product.handle === 'cal-max-snap-frame') || null

  const [updatingPrices, setUpdatingPrices] = useState(false)
  const [gettingCheckout, setGettingCheckout] = useState(false)
  const [displayPopup, setDisplayPopup] = useState(false)
  const [hasFrame2, setHasFrame2] = useState(false)
  const [hasFrame, setHasFrame] = useState(false)
  const [hasFrameSnapFrame, setHasFrameSnapFrame] = useState(false)
  // const [hasBetterHelp, setHasBetterHelp] = useState(false)
  const [hasCalendar, setHasCalendar] = useState(false)
  // const [hasCalendarPlus, setHasCalendarPlus] = useState(false)

  // const [displayFrameUpsell, setDisplayFrameUpsell] = useState(false)

  const [checkShowPopup, setcheckShowPopup] = useState(false)
  const [displayToolTip, setDisplayToolTip] = useState(false)
  const noopCalendarSetter = useCallback(() => {}, [])

  // const inSeasonalState =
  //   (!IS_FOREIGN_COUNTRY && (IN_SEASONAL_STATE || promoCode === VIP_CODE)) ||
  //   (IN_CA && IN_SEASONAL_STATE)
  // const FRAME_UPSELL_DETAILS = {
  //   Black: {
  //     image: frameBlackDeal,
  //     desktopImage: frameBlackDeal,
  //     variantId: BLACK_FRAME_VARIANT_ID[LOCALIZATION],
  //   },
  //   Silver: {
  //     image: frameSilverDeal,
  //     desktopImage: frameSilverDealDesktop,
  //     variantId: 'gid://shopify/ProductVariant/41085768302644',
  //   },
  // }

  /**
   * Nested array/object destructuring with default values:
   * Basically for each level of nesting, we are giving the array/object we are
   * trying to destructure out of a default value of empty array/object to avoid null errors .
   */
  const {
    discountAllocations = [],
    cost: { subtotalAmount: { amount: subtotalAmount } = {} } = {},
    totalQuantity,
    lines: { edges: lineItems = [] } = {},
  } = cart

  const buyingPlus = isUserBuyingPlus(cart)
  const buyingCalendar = isUserBuyingCalendar(cart)

  const discountAmountString = lineItems
    .reduce(
      (total, lineItem) =>
        total +
        lineItem?.node?.discountAllocations?.reduce(
          (lineTotal, allocation) => lineTotal + parseFloat(allocation.discountedAmount.amount),
          0
        ),
      0
    )
    .toFixed(2)
  let discountAmount = parseFloat(discountAmountString) || 0
  const cartLevelDiscount = discountAllocations.length > 0

  const subtotalNumber = parseFloat(subtotalAmount)
  let displayedSubtotal = subtotalNumber + discountAmount
  let displayedTotal = subtotalNumber

  if (discountAmount === 0 && cartLevelDiscount) {
    discountAmount = discountAllocations.reduce(
      (total, allocation) => total + parseFloat(allocation.discountedAmount.amount),
      0
    )
    displayedSubtotal = subtotalNumber
    displayedTotal = subtotalNumber - discountAmount
  }
  const TRACKER_PARAM_TIMEOUT_MILLI = 1000

  const safeTrackerParam = (cb) => {
    let finished = false
    setTimeout(() => {
      if (!finished) cb()
    }, TRACKER_PARAM_TIMEOUT_MILLI)
    // eslint-disable-next-line no-undef
    ga((tracker) => {
      const param = tracker.get('linkerParam')
      finished = true
      cb(param)
    })
  }

  const handleCheckout = async () => {
    setGettingCheckout(true)
    Analytics.track('Initiated Checkout')
    window.dataLayer = window.dataLayer || []
    const products = cart.lines.edges.map(({ node }) => ({
      id: node.merchandise.id,
      name: node.merchandise.product.title,
      price: parseFloat(node.merchandise.priceV2.amount),
      quantity: node.quantity,
    }))
    window.dataLayer.push({
      event: 'beginCheckout',
      ecommerce: {
        currencyCode,
        beginCheckout: products,
        value: parseFloat(displayedTotal),
      },
    })

    let queryString = ''
    const utmParams = UTMParams.get()
    Object.keys(utmParams).forEach((k) => (queryString += `&${k}=${utmParams[k]}`))
    const baseUrl = cart.checkoutUrl
    setGettingCheckout(false)
    safeTrackerParam((param) => {
      if (param) queryString += `&${param}`
      window.location = baseUrl + queryString
    })
  }

  const handleApplyDiscount = async (discount) => {
    if (!discount) return
    await applyDiscount(discount)
  }

  const discountsArray = [{ applicableItemHandles: [] }]

  const bannerInfo = LocalStorage.getItem('banner')

  useEffect(() => {
    if (cart?.lines?.edges?.length) {
      if (shouldRemoveReturnGuarantee(cart?.lines?.edges)) {
        removeLineItem(
          cart?.lines?.edges.find(
            (item) => item.node.merchandise.product.handle === RETURN_GUARANTEE_PRODUCT_HANDLE
          )?.node?.id
        )
      }
      if (shouldRemoveBetterHelpProduct(cart?.lines?.edges)) {
        removeLineItem(
          cart?.lines?.edges.find(
            (item) => item.node.merchandise.product.handle === LOVEVERY_PRODUCT_HANDLE
          )?.node?.id
        )
      }
    }
    if (
      !checkShowPopup &&
      cart?.lines?.edges?.length &&
      hasFrame2 &&
      !hasFrameSnapFrame &&
      snapFrame
    ) {
      const timer = setTimeout(() => {
        setDisplayPopup(true)
        setcheckShowPopup(true)
      }, 3000)

      return () => clearTimeout(timer)
    }

    // if (cart?.lines?.edges?.length && !hasFrame2 && !hasFrame && hasCalendar && !IN_AU) {
    //   const timer = setTimeout(() => {
    //     if (IN_SEASONAL_STATE || promoCode === VIP_CODE || (IS_FOREIGN_COUNTRY && !IN_AU)) {
    //       setDisplayFrameUpsell(true)
    //     }
    //   }, 1000)

    //   return () => clearTimeout(timer)
    // }
  }, [
    cart,
    checkShowPopup,
    hasFrame2,
    hasFrameSnapFrame,
    hasCalendar,
    hasFrame,
    removeLineItem,
    snapFrame,
  ])

  if (loading) {
    return (
      <CenteredContent>
        <img src={loadingGif} alt="Loading your cart..." />
      </CenteredContent>
    )
  }
  if (cart?.lines?.edges?.length === 0) {
    return (
      <Container>
        <Header>
          <Trans>You have no items in your cart. Check out our products!</Trans>
        </Header>
        <ProductListContainer>
          <ProductsList />
        </ProductListContainer>
      </Container>
    )
  }
  // const isDiscountApplied = Object.values(DISCOUNTS).includes(discountCode) && discountAmount > 0
  const items = cart?.lines?.edges.map((item) => (
    <LineItem
      key={item.node.id.toString()}
      item={item}
      discountsArray={discountsArray}
      updatingPrices={updatingPrices}
      setUpdatingPrices={setUpdatingPrices}
      // availableDiscount={availableDiscount}
      // setAvailableDiscount={setAvailableDiscount}
      // appliedBundleDiscount={appliedBundleDiscount}
      // setAppliedBundleDiscount={setAppliedBundleDiscount}
      bannerInfo={bannerInfo}
      strikethrough={false}
      subtotalQuantity={totalQuantity}
      setHasFrame2={setHasFrame2}
      setHasFrame={setHasFrame}
      setHasFrameSnapFrame={setHasFrameSnapFrame}
      setHasCalendarSnapFrame={noopCalendarSetter}
      // setHasBetterHelp={setHasBetterHelp}
      setHasCalendar={setHasCalendar}
      setHasCalendarPlus={noopCalendarSetter}
      setHasCalendar2={noopCalendarSetter}
      setHasCalendarMax={noopCalendarSetter}
      isFreeProduct={item?.node?.merchandise?.product?.handle === RETURN_GUARANTEE_PRODUCT_HANDLE}
      isBetterHelpProduct={item?.node?.merchandise?.product?.handle === LOVEVERY_PRODUCT_HANDLE}
    />
  ))

  const variantImageMap = {
    calendar2: {
      Classic: {
        White: cal2ClassicWhiteImage.childImageSharp.gatsbyImageData,
        Black: cal2ClassicBlackImage.childImageSharp.gatsbyImageData,
        Sage: cal2ClassicSageImage.childImageSharp.gatsbyImageData,
        Lagoon: cal2ClassicLagoonImage.childImageSharp.gatsbyImageData,
      },
      'Shadow Box': {
        Charcoal: cal2ShadowBoxCharcoalImage.childImageSharp.gatsbyImageData,
        Silver: cal2ShadowBoxSilverImage.childImageSharp.gatsbyImageData,
      },
    },
    calendarMax: {
      Classic: {
        White: calMaxClassicWhiteImage.childImageSharp.gatsbyImageData,
        Black: calMaxClassicBlackImage.childImageSharp.gatsbyImageData,
      },
      'Shadow Box': {
        Charcoal: calMaxShadowBoxCharcoalImage.childImageSharp.gatsbyImageData,
        Silver: calMaxShadowBoxSilverImage.childImageSharp.gatsbyImageData,
      },
      Wood: {
        Birch: calMaxWoodBirchImage.childImageSharp.gatsbyImageData,
        Walnut: calMaxWoodWalnutImage.childImageSharp.gatsbyImageData,
      },
    },
  }

  const hasCalendar2InCart = lineItems.some(({ node }) =>
    (node?.merchandise?.product?.title || '').includes('Calendar 2')
  )
  const hasCalendarMaxInCart = lineItems.some(({ node }) =>
    (node?.merchandise?.product?.title || '').includes('Calendar Max')
  )
  const hasCalendarSnapFrameInCart = lineItems.some(({ node }) => {
    const title = node?.merchandise?.product?.title || ''
    return title.includes('Snap Frame') && title.includes('Calendar')
  })

  const hasEligibleCalendarForSnapCrossSell = hasCalendar2InCart || hasCalendarMaxInCart

  // const foreignUpsellBannerCopy = (
  //   <>
  //     <b>
  //       Add a 10" Frame in {IS_FOREIGN_COUNTRY ? 'Black' : FRAME_UPSELL_COLOR}{' '}
  //       {CURRENT_SEASONAL_STATE === 'bau' ? (
  //         <span>{FRAME_OG_PRICE[LOCALIZATION]}</span>
  //       ) : (
  //         <>
  //           <Strikethrough>{FRAME_OG_PRICE[LOCALIZATION]}</Strikethrough>{' '}
  //           <RedText>{FRAME_DISCOUNTED_PRICE[LOCALIZATION]}</RedText>
  //         </>
  //       )}
  //     </b>
  //     <BannerText small showOnMobile>
  //       The perfect gift that keeps your entire family connected!
  //     </BannerText>
  //   </>
  // )

  // const mdUpsellBannerCopy = (
  //   <>
  //     <HiddenImageOnDesktop>
  //       <Centered>
  //         <YotpoStars color={theme.gold} productId="7073751498804" />
  //       </Centered>
  //     </HiddenImageOnDesktop>
  //     <HiddenOnMobile>
  //       <b>Special Offer for Calendar Shoppers!</b>
  //     </HiddenOnMobile>
  //     <BannerText small showOnMobile>
  //       Instantly share photos to keep grandma, grandpa, and everyone else in the loop.
  //     </BannerText>
  //   </>
  // )
  // const mobileUpsellBannerCopy = inSeasonalState ? mdUpsellBannerCopy : foreignUpsellBannerCopy
  // const desktopUpsellBannerCopy = inSeasonalState ? mdUpsellBannerCopy : foreignUpsellBannerCopy

  // const showFrameDeal = IS_FOREIGN_COUNTRY && !IN_AU
  return (
    <>
      {displayPopup && snapFrame && (
        <Popup
          snapFrame={snapFrame}
          setDisplayPopup={setDisplayPopup}
          cartLines={cart?.lines}
          handleApplyDiscount={handleApplyDiscount}
        />
      )}
      {displayToolTip && (
        <ToolTip
          setDisplayToolTip={setDisplayToolTip}
          onClick={() => Analytics.track('Clicked Tooltip in Cart CTA')}
          amount={FormattedCurrency(displayedTotal / 4)}
        />
      )}
      <CheckoutContainer>
        {/* {SHOW_BETTER_HELP_DESIGN && hasCalendar && (
          <BetterHelpOffer offerRedeemed={hasBetterHelp} setHasBetterHelp={setHasBetterHelp} />
        )} */}
        {/* {displayFrameUpsell && showFrameDeal && (
          <Banner>
            <TextContainer>
              <HiddenImageOnDesktop>
                {!IS_FOREIGN_COUNTRY && <b>Special Offer for Calendar Shoppers!</b>}
                <FrameDealImage>
                  <Link to={BUY_LINK}>
                    <GatsbyImage
                      image={
                        IS_FOREIGN_COUNTRY
                          ? FRAME_UPSELL_DETAILS.Black.image.childImageSharp.gatsbyImageData
                          : FRAME_UPSELL_DETAILS[FRAME_UPSELL_COLOR].image.childImageSharp
                              .gatsbyImageData
                      }
                      alt={`10in ${
                        IS_FOREIGN_COUNTRY ? 'Black' : FRAME_UPSELL_COLOR
                      } Frame Special Deal`}
                    />
                  </Link>
                  {inSeasonalState && (
                    <DiscountBadge
                      image={
                        IN_CA
                          ? Badge_30.childImageSharp.gatsbyImageData
                          : Badge_60.childImageSharp.gatsbyImageData
                      }
                      alt={IN_CA ? '$30 off badge' : '$60 off badge'}
                    />
                  )}
                </FrameDealImage>
                <BannerText hideOnDesktop>{mobileUpsellBannerCopy}</BannerText>
              </HiddenImageOnDesktop>
              <HiddenOnMobile>
                <FrameDealImage>
                  <Link to={BUY_LINK}>
                    <GatsbyImage
                      image={
                        IS_FOREIGN_COUNTRY
                          ? FRAME_UPSELL_DETAILS.Black.desktopImage.childImageSharp.gatsbyImageData
                          : FRAME_UPSELL_DETAILS[FRAME_UPSELL_COLOR].desktopImage.childImageSharp
                              .gatsbyImageData
                      }
                      alt={`10in ${
                        IS_FOREIGN_COUNTRY ? 'Black' : FRAME_UPSELL_COLOR
                      } Frame Special Deal`}
                    />
                  </Link>
                </FrameDealImage>
              </HiddenOnMobile>
              <div>
                <BannerText>{desktopUpsellBannerCopy}</BannerText>
              </div>
            </TextContainer>
            <AddToCartButton
              widerButton
              label={
                IS_FOREIGN_COUNTRY && !IN_CA ? (
                  'Get the Deal'
                ) : (
                  <>
                    {' '}
                    {CURRENT_SEASONAL_STATE === 'bau' ? (
                      <>
                        Add Frame for <s>{FRAME_OG_PRICE_BAU[LOCALIZATION]}</s>{' '}
                        {FRAME_DISCOUNTED_PRICE_BAU[LOCALIZATION]}
                      </>
                    ) : (
                      <>
                        Add Frame for <s>{FRAME_OG_PRICE[LOCALIZATION]}</s>{' '}
                        {FRAME_DISCOUNTED_PRICE[LOCALIZATION]}
                      </>
                    )}
                  </>
                )
              }
              adding={submitting}
              handleClick={async () => {
                Analytics.track('Added Frame Cross Sell Deal to Cart')
                await handleAddToCart(
                  IS_FOREIGN_COUNTRY
                    ? FRAME_UPSELL_DETAILS.Black.variantId
                    : FRAME_UPSELL_DETAILS[FRAME_UPSELL_COLOR].variantId
                )
                setDisplayFrameUpsell(false)
              }}
              oos={false}
            />
          </Banner>
        )} */}
        {!IS_FOREIGN_COUNTRY &&
          hasEligibleCalendarForSnapCrossSell &&
          !hasCalendarSnapFrameInCart &&
          !IN_SEASONAL_STATE &&
          promoCode !== VIP_CODE && (
            <CalendarSnapFrameCrossSell
              cartLines={lineItems}
              snapProducts={{
                calendar2: calendar2SnapFrame,
                calendarMax: calendarMaxSnapFrame,
              }}
              variantImageMap={variantImageMap}
              fallbackImageData={snapFrameFallbackImage.childImageSharp.gatsbyImageData}
              handleAddToCart={handleAddToCart}
              adding={submitting}
            />
          )}
        <Table>
          <thead>
            <tr>
              <TableHeader textAlign="left">
                <Trans>Product</Trans>
              </TableHeader>
              <DesktopOnlyTableHeader width="118px">
                <Trans>Price</Trans>
              </DesktopOnlyTableHeader>
              <QuantityHeader width="118px">
                <Trans>Quantity</Trans>
              </QuantityHeader>
              <DesktopOnlyTableHeader width="118px">
                <Trans>Subtotal</Trans>
              </DesktopOnlyTableHeader>
              <HiddenOnDesktop>
                <TableHeader width="60px">
                  <Trans>Price</Trans>
                </TableHeader>
              </HiddenOnDesktop>
            </tr>
          </thead>
          <tbody>{items}</tbody>
        </Table>
        <DisplayOnDesktop>
          <Table>
            <thead>
              <TableHeader textAlign="left" />
              {discountAmount > 0 ? (
                <>
                  <TableHeader width="118px">
                    <Trans>Subtotal</Trans>
                  </TableHeader>
                  <QuantityHeader width="118px">
                    <Trans>Discount</Trans>
                  </QuantityHeader>
                </>
              ) : (
                <>
                  <TableHeader />
                  <TableHeader />
                </>
              )}
              <DesktopOnlyTableHeader width="118px">
                <Trans>Grand Total</Trans>
              </DesktopOnlyTableHeader>
            </thead>
            <tbody>
              <TableRow>
                <TD />
                {discountAmount > 0 ? (
                  <>
                    <TD>
                      <LineItemTotal>
                        {updatingPrices ? (
                          <LoadingEllipsis />
                        ) : (
                          <s>{FormattedCurrency(displayedSubtotal)}</s>
                        )}
                      </LineItemTotal>
                    </TD>
                    <TD>
                      {discountAmount > 0 && (
                        <Discount>
                          <>
                            {updatingPrices ? (
                              <LoadingEllipsis />
                            ) : (
                              <Amount color="#2178af">{` ${FormattedCurrency(
                                discountAmount
                              )}`}</Amount>
                            )}
                          </>
                        </Discount>
                      )}
                    </TD>
                  </>
                ) : (
                  <>
                    <TD />
                    <TD />
                  </>
                )}
                <TD>
                  <Total>
                    {updatingPrices ? (
                      <Spinner />
                    ) : (
                      <Amount color="#f66951">{FormattedCurrency(displayedTotal)}</Amount>
                    )}
                  </Total>
                </TD>
              </TableRow>
            </tbody>
          </Table>
        </DisplayOnDesktop>
        <Checkout>
          <DisplayOnMobile>
            {discountAmount > 0 && (
              <>
                <LineItemTotal>
                  <span>
                    <Trans>Subtotal</Trans>
                  </span>
                  {updatingPrices ? (
                    <LoadingEllipsis />
                  ) : (
                    <Subtotal strikethrough={false}>
                      {FormattedCurrency(displayedSubtotal)}
                    </Subtotal>
                  )}
                </LineItemTotal>
                {discountAmount > 0 && (
                  <Discount>
                    <>
                      <span>
                        <Trans>Discount</Trans>{' '}
                      </span>
                      {updatingPrices ? (
                        <LoadingEllipsis />
                      ) : (
                        <DiscountText>{FormattedCurrency(discountAmount)}</DiscountText>
                      )}
                    </>
                  </Discount>
                )}
              </>
            )}
            <Total>
              <span>
                <Trans>Grand Total</Trans>
              </span>
              {updatingPrices ? <Spinner /> : <span>{FormattedCurrency(displayedTotal)}</span>}
            </Total>
          </DisplayOnMobile>
          {!IN_UK && (
            <Excluding>
              <Trans>Excluding Tax and Shipping</Trans>
            </Excluding>
          )}
          {!IS_FOREIGN_COUNTRY && buyingCalendar && !buyingPlus && (
            <>
              <Offer>
                Limited time offer: Financing from 0% APR* and 4 interest-free payments of{' '}
                {FormattedCurrency(displayedTotal / 4)} with
              </Offer>
              <ShopPay onTooltipClick={() => setDisplayToolTip(true)} isCart />
            </>
          )}
          {totalQuantity > 9 && (
            <Error>
              <Trans>
                Your cart has exceeded our 8-item limit. To keep your order shipping quickly and
                securely, we can only process up to 8 items at a time. Please adjust your cart to
                continue to checkout.
              </Trans>{' '}
            </Error>
          )}
          <CheckoutButtons marginTop={IN_UK}>
            {!buyingPlus && !IN_AU && (
              <PayPalCheckoutButton
                color="#ffc439"
                type="button"
                onClick={handleCheckout}
                disabled={cart?.lines?.edges?.length === 0 || totalQuantity > 9}
              >
                <GatsbyImage image={paypalLogo.childImageSharp.gatsbyImageData} alt="PayPal Logo" />
              </PayPalCheckoutButton>
            )}

            <CheckoutButton
              color={theme.coral}
              type="button"
              onClick={handleCheckout}
              disabled={cart?.lines?.edges?.length === 0 || totalQuantity > 9}
            >
              {gettingCheckout ? <Spinner color="white" size={26} /> : t('Check Out')}
            </CheckoutButton>
          </CheckoutButtons>
        </Checkout>
      </CheckoutContainer>{' '}
    </>
  )
}

export default Cart

Cart.propTypes = {
  handleAddToCart: PropTypes.func.isRequired,
  submitting: PropTypes.bool,
}
